import { A } from '@adornis/base/env-info.js';
import type { Maybe } from '@adornis/base/utilTypes.js';
import { Float, Int } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';
import type { IRouteTicket, IRouteTicketAssigned } from '../types.js';

@Entity()
export class RouteTicket extends AdornisEntity implements IRouteTicket {
  static override _class = 'RouteTicket';

  static override resolveID(entity: RouteTicket): string {
    // use a globally unique id to avoid overriding lat/lng for the same ticket
    return A.getGloballyUniqueID();
    // return entity.id ?? A.getGloballyUniqueID();
  }

  @Field(_type => String) id?: string;
  @Field(_type => String) number?: string;
  @Field(_type => String) pudoName?: string;
  @Field(_type => String) address?: string;
  @Field(_type => String) zip?: string;
  @Field(_type => String) city?: string;
  @Field(_type => String) country?: string;
  @Field(_type => Float) lat?: number;
  @Field(_type => Float) lng?: number;
  @Field(_type => String) type?: 'Client' | 'Enterprise' | 'HES' | 'IMAC' | 'Other';
  @Field(_type => String) depotId?: string;
  @Field(_type => Boolean) requiresPudoVisit?: boolean;
  @Field(_type => Int) serviceDurationSeconds?: number; // Individuelle Service-Dauer in Sekunden (optional)
  @Field(_type => [String]) assignableEmployeeIds?: string[]; // Optional: Nur diese Mitarbeiter können zugewiesen werden
  @Field(_type => String) project?: string;

  /** used for checksum calculation, when we have unknown fes assigned to show this in the UI */
  @Field(_type => String) wasAssignedTo: Maybe<string>;
  @Field(_type => String) comment: Maybe<string>;

  constructor(doc: PartialEntityData<RouteTicket>) {
    super(doc);
  }
}

@Entity()
export class RouteTicketAssigned extends RouteTicket implements IRouteTicketAssigned {
  static override _class = 'RouteTicketAssigned';

  @validate(nonOptional())
  @Field(_type => String)
  employeeId!: string;

  @Field(_type => Boolean)
  fixedFE: Maybe<boolean>;

  @Field(_type => Date)
  startTime: Maybe<Date>;

  @Field(_type => Date)
  endTime: Maybe<Date>;

  constructor(doc: PartialEntityData<RouteTicketAssigned>) {
    super(doc);
  }
}
